import { addPermissionsToRoute } from '@qsrsoft/myq-core';

const routes = {
  name: 'Sales',
  icon: 'mdi-chart-line',
  path: '/reports/mcd/sales/',
  children: [
    {
      path: '/reports/mcd/sales/deliveryReport',
      name: 'McDelivery',
      meta: { id: 'reports-mcDelivery' },
      component: () => import('./delivery/DeliveryWrapper.vue'),
      ...addPermissionsToRoute(['delivery']),
      tags: ['Delivery Sales', 'Delivery By Vendor'],
    },
    {
      path: '/reports/mcd/sales/kiosk',
      name: 'Kiosk',
      meta: { id: 'reports-kiosk' },
      component: () => import('./kiosk/Wrapper.vue'),
      ...addPermissionsToRoute(['kiosk']),
    },
    {
      path: '/reports/mcd/sales/salesLedger',
      name: 'Sales Ledger',
      meta: { id: 'reports-salesLedger' },
      component: () => import('@/views/standard/sales/SalesLedger.vue'),
      ...addPermissionsToRoute(['salesLedger']),
    },
    {
      path: '/reports/mcd/sales/consolidatedSales',
      name: 'Consolidated Sales',
      meta: { id: 'reports-consolidatedSales' },
      component: () =>
        import(
          '@/views/standard/sales/consolidatedSales/ConsolidatedSales.vue'
        ),
      ...addPermissionsToRoute(['consolidatedSales']),
    },
    {
      path: '/reports/mcd/sales/salesPointOfOrder',
      name: 'Sales - Point Of Order',
      meta: { id: 'reports-salesPointOfOrder' },
      component: () => import('./salesPointOfOrder.vue'),
      tags: ['POO', 'Daily Sales'],
      ...addPermissionsToRoute(['salesPointOfOrder']),
    },
    {
      path: '/reports/mcd/sales/salesWhereServed',
      name: 'Where Served',
      meta: { id: 'reports-salesWhereServed' },
      component: () => import('./salesWhereServed.vue'),
      ...addPermissionsToRoute(['salesWhereServed']),
    },
    {
      path: '/reports/mcd/sales/salesLedgerSummary',
      name: 'Sales Ledger Summary',
      meta: { id: 'reports-salesLedgerSummary' },
      component: () => import('./salesLedgerSummary.vue'),
      ...addPermissionsToRoute(['salesLedgerSummary']),
    },
    {
      path: '/reports/mcd/sales/storeHours',
      name: 'Store Hours',
      meta: { id: 'reports-storeHours' },
      component: () => import('./storeHours.vue'),
      ...addPermissionsToRoute(['storeHours']),
    },
    {
      path: '/reports/mcd/sales/openLateCloseEarly',
      name: 'Open Late Close Early',
      meta: { id: 'reports-openLateCloseEarly' },
      component: () => import('./openLateCloseEarly.vue'),
      ...addPermissionsToRoute(['storeHours']),
    },
  ],
};

export default routes;
